import { render, staticRenderFns } from "./ExchangeList.vue?vue&type=template&id=129c3bc4&scoped=true&"
import script from "./ExchangeList.vue?vue&type=script&lang=js&"
export * from "./ExchangeList.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeList.vue?vue&type=style&index=0&id=129c3bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c3bc4",
  null
  
)

export default component.exports